{
  "columns": [],
  "buttons": [],
  "apiDetails": "mass-adjustment-list.json",
  "pageName": "massbatcherrorlist",
  "orderByColumn": ["modifiedDate"],
  "orderBy": ["desc"]
}
